<template>
    <div>
        <div id="world" ref="world" :class="worldClass" v-if="backdropType==='sunrise'" :style="{'min-height': backdropMinHeight}">
            <div style="margin-top:40px; margin-left:395px; margin-right:20px;">
                <slot></slot>
            </div>
            <div id="sun" :style="{ top: sunHeight + 'px', left: sunMoonLeft + 'px', height: sunMoonSize + 'px', width: sunMoonSize + 'px' }">
                <div class="sunbeams" :style="{ height: sunBeamAreaSize + 'px', width: sunBeamAreaSize + 'px', top: sunBeamAreaOffset + 'px', left: sunBeamAreaOffset + 'px' }">
                    <div class="beam beam1" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam2" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam3" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam4" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam5" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam6" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam7" :style="{height: sunBeamSize + 'px'}"></div>
                    <div class="beam beam8" :style="{height: sunBeamSize + 'px'}"></div>
                </div>
                <div class="eyes" :style="{height: eyesHeight + 'px', width: eyesWidth + 'px', top: eyesTop + 'px', left: eyesLeft + 'px'}">
                    <div class="eyes-l" :style="{height: eyesHeight + 'px', width: eyesHeight + 'px'}"></div>
                    <div class="eyes-r" :style="{height: eyesHeight + 'px', width: eyesHeight + 'px'}"></div>
                </div>
            </div>
            <div id="moon" :style="{ top: moonHeight + 'px', left: sunMoonLeft + 'px', height: sunMoonSize + 'px', width: sunMoonSize + 'px' }">
                <div class="crater crater1"></div>
                <div class="crater crater2"></div>
                <div class="crater crater3"></div>
                <div class="crater crater4"></div>
                <div class="crater crater5"></div>
                <div class="crater crater6"></div>
                <div class="eyes" :style="{height: eyesHeight + 'px', width: eyesWidth + 'px', top: eyesTop + 'px', left: eyesLeft + 'px'}">
                    <div class="eyes-l" :style="{height: eyesHeight + 'px', width: eyesHeight + 'px'}"></div>
                    <div class="eyes-r" :style="{height: eyesHeight + 'px', width: eyesHeight + 'px'}"></div>
                </div>
            </div>
        </div>
        <div v-else>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'backdrop',
    props: {
        currentUser: Object,
        backdropType: String,
        backdropMinHeight: String
    },
    data() {
        return {
            userSettingsDialog: false,
            sunMoonSize: 0,
            worldWidth: 0,
            worldHeight: 0,
        };
    },
    computed: {
        hourNow() {
            return moment().hour();
        },
        moonHeight() {
            return this.sunMoonPos('moon');
        },
        sunMoonLeft() {
            if (this.worldWidth > 700) return 50 + this.sunBeamSize;
            if (this.worldWidth > 500) return 30 + this.sunBeamSize;
            return 10 + this.sunBeamSize;
        },
        sunHeight() {
            return this.sunMoonPos('sun');
        },
        sunBeamSize() {
            return this.sunMoonSize * 0.25;
        },
        sunBeamAreaSize() {
            return this.sunMoonSize * 1.5;
        },
        sunBeamAreaOffset() {
            return ((this.sunMoonSize - this.sunBeamAreaSize) / 2) - 3;
        },
        eyesWidth() {
            return this.sunMoonSize * 0.5;
        },
        eyesHeight() {
            return this.sunMoonSize * 0.10;
        },
        eyesTop() {
            return (this.sunMoonSize * 0.5) - this.eyesHeight;
        },
        eyesLeft() {
            return this.sunMoonSize * 0.23;
        },
        sunMoonPos() {
            return (type) => {
                let o = 0;
                const hour = this.hourNow;
                // hourPecent should equal closest to 0 when hour = 17, and when hour = 2;
                let hiddenTop = this.worldHeight + 100;
                const hourPercents = [
                    0, // midnight
                    0.12,
                    0.25,
                    0.4,
                    0.55,
                    0.7,
                    0.85, // Sunrise 6am
                    0.7,
                    0.6,
                    0.5,
                    0.4,
                    0.3,
                    0.2, // noon
                    0.1,
                    0,
                    0.1,
                    0.25,
                    0.5,
                    0.65,
                    0.85,
                    0.7, // Sunset 8pm
                    0.55,
                    0.4,
                    0.25 // 11pm
                ];
                let visibleTop = hourPercents[hour] * this.worldHeight;
                if (visibleTop === 0) visibleTop = 10;
                if ((hour < 6) || (hour >= 20)) {
                    o = type === 'sun' ? hiddenTop : visibleTop;
                } else {
                    o = type === 'sun' ? visibleTop : hiddenTop;
                }
                return o;
            };
        },
        worldClass() {
            let c;
            const h = this.hourNow;
            if (h >= 0 && h < 4) c = 'world-night'; // NOSONAR
            if (h >= 4 && h < 7) c = 'world-morning'; // NOSONAR
            if (h >= 7 && h < 9) c = 'world-sunrise'; // NOSONAR
            else if (h >= 9 && h < 17) c = 'world-day'; // NOSONAR
            else if (h >= 17 && h < 19) c = 'world-evening'; // NOSONAR
            else if (h >= 19 && h < 24) c = 'world-night'; // NOSONAR
            return c;
        },
        textClass() {
            let c;
            const h = this.hourNow;
            if (h >= 0 && h < 5) c = 'blue--text text--lighten-5'; // NOSONAR
            if (h >= 5 && h < 8) c = 'blue--text text--lighten-5'; // NOSONAR
            else if (h >= 8 && h < 17) c = 'blue--text text--darken-4'; // NOSONAR
            else if (h >= 17 && h < 19) c = 'blue--text text--lighten-5'; // NOSONAR
            else if (h >= 19 && h < 24) c = 'blue--text text--lighten-5'; // NOSONAR
            return c;
        },
        dayTimeLabel() {
            let c;
            const h = this.hourNow;
            if (h >= 0 && h < 5) c = 'night'; // NOSONAR
            if (h >= 5 && h < 11) c = 'morning'; // NOSONAR
            else if (h >= 11 && h < 13) c = 'day'; // NOSONAR
            else if (h >= 13 && h < 17) c = 'afternoon'; // NOSONAR
            else if (h >= 17 && h < 19) c = 'evening'; // NOSONAR
            else if (h >= 19 && h < 24) c = 'night'; // NOSONAR
            return c;
        }
    },
    methods: {
        setSunMoonSize() {
            this.worldHeight = this.$refs
                && this.$refs.world
                && this.$refs.world.clientHeight;
            this.worldWidth = this.$refs
                && this.$refs.world
                && this.$refs.world.clientWidth;
            let messageBoxWidth = 300;
            let maxWidth = Math.max(this.worldWidth - messageBoxWidth, 360);
            let maxHeight = this.worldHeight;
            let maxDimension = 500;
            this.sunMoonSize = Math.min(maxHeight, maxWidth, maxDimension) * 0.5;
        }
    },
    mounted() {
        if (this.backdropType === 'sunrise' && this.$refs.world) {
            const backdropResize = new ResizeObserver(() => {
                this.setSunMoonSize();
            });
            backdropResize.observe(this.$refs.world);
        }
    }
};
</script>

<style scoped>
#world {
    width: 100%;
    position: relative;
    overflow: hidden;
    border-bottom: 5px solid #7a6021;
    transition: border 0.5s ease;
}
.world-morning {
    background: #393b7d;
}
.world-sunrise {
    background: #7a6081;
}
.world-day {
    background: #ffed90;
}
.world-evening {
    background: #d4978d;
}
.world-night {
    background: #021e3f;
}
#sun {
    background-color: #f4c042;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
    top: 50px;
    left: 90px;
    border-width: 3px;
    border-style: solid;
    border-color: #7a6021;
    transition: top 0.1s ease;
}
.world-sunrise #sun {
    border-color: #b49728;
}
#moon {
    background-color: #95c7fa;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
    top: 50px;
    left: 90px;
    border: 3px solid #67a8f1;
    transition: top 0.1s ease;
}
.crater {
    position: absolute;
    border-radius: 50%;
    background: #67a8f1;
}
.crater1 {
    width: 15%;
    height: 15%;
    top: 23%;
    left: 15%;
}
.crater2 {
    width: 8%;
    height: 8%;
    top: 10%;
    left: 50%;
}
.crater3 {
    width: 20%;
    height: 20%;
    top: 25%;
    left: 75%;
}
.crater4 {
    width: 25%;
    height: 25%;
    top: 50%;
    left: 15%;
}
.crater5 {
    width: 12%;
    height: 12%;
    top: 80%;
    left: 40%;
}
.crater6 {
    width: 13%;
    height: 13%;
    top: 60%;
    left: 70%;
}

.beam {
    width: 3px;
    background: #7a6021;
    position: absolute;
}
.world-sunrise .beam{
    background: #b49728;
}

.beam1 {
    transform: rotate(0deg);
    top: -5%;
    left: 49%;
}
.beam2 {
    transform: rotate(45deg);
    top: 10%;
    left: 82%;
}
.beam3 {
    transform: rotate(90deg);
    top: 42%;
    left: 95%;
}
.beam4 {
    transform: rotate(135deg);
    top: 75%;
    left: 80%;
}
.beam5 {
    transform: rotate(180deg);
    top: 88%;
    left: 49%;
}
.beam6 {
    transform: rotate(225deg);
    top: 75%;
    left: 16%;
}
.beam7 {
    transform: rotate(270deg);
    top: 42%;
    left: 4%;
}
.beam8 {
    transform: rotate(315deg);
    top: 10%;
    left: 15%;
}
.sunbeams {
    position: absolute;
    animation: spin 28s linear 0s infinite;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes blink {
    0% {
        height: inherit;
        top: 0;
    }
    99% {
        height: inherit;
        top: 0;
    }
    100% {
        height: 0px;
        top: 50%;
    }
}
.eyes {
    position: absolute;
}
.eyes div {
    top: 0;
    border-radius: 50%;
    position: absolute;
    animation: blink 7s linear 0s infinite;
}
.eyes-l {
    left: 0;
}
.eyes-r {
    right: 0;
}
#moon .eyes-l,
#moon .eyes-r {
    background: #0f2964;
}
#sun .eyes-l,
#sun .eyes-r {
    background: #4f0504;
}
</style>
